import { Text } from 'bold-ui'
import React from 'react'
import { useParams } from 'react-router'

export interface AgendamentoCidadaoViewParams {
  cidadaoId: ID
}

export function AgendamentosCidadaoView(props) {
  const params = useParams<AgendamentoCidadaoViewParams>()
  return <Text> Agendamentos: {params.cidadaoId}</Text>
}
